import * as tslib_1 from "tslib";
import BrandSubscriptionDetails from './BrandSubscriptionDetails';
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
var styles = require('./BrandSubscriptionView.scss');
var BrandSubscriptionView = /** @class */ (function (_super) {
    tslib_1.__extends(BrandSubscriptionView, _super);
    function BrandSubscriptionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDisplayName = function () {
            var subscription = _this.props.brandSubscriptions[0];
            return subscription.type === 'BrandSubscription'
                ? subscription.brand.brandName
                : subscription.smtpInfo.displayName;
        };
        _this.getEmailAddress = function () {
            return _this.props.brandSubscriptions[0].smtpInfo.smtpAddress;
        };
        _this.getBrandSubscriptionDetails = function () {
            var detailsView = _this.props.brandSubscriptions.map(function (subscription) {
                return (React.createElement(BrandSubscriptionDetails, { displayName: subscription.smtpInfo.displayName, smtp: subscription.smtpInfo.smtpAddress, smtpIdentifier: subscription.smtpInfo.smtpIdentifier, unsubscribeHttpUri: subscription.unsubscribeHttpUris[0], unsubscribeSilentUris: subscription.unsubscribeSilentUris, key: subscription.smtpInfo.smtpAddress, isUnsubscribed: _this.props.isUnsubscribed }));
            });
            return detailsView;
        };
        return _this;
    }
    BrandSubscriptionView.prototype.render = function () {
        var displayName = this.getDisplayName();
        return (React.createElement("div", { className: styles.brandView },
            React.createElement("span", null,
                React.createElement(PersonaControl, { name: displayName, emailAddress: this.getEmailAddress(), size: PersonaSize.size72, showPersonaDetails: false })),
            React.createElement("span", { className: styles.details },
                React.createElement("span", { className: styles.brandName },
                    " ",
                    displayName,
                    " "),
                this.getBrandSubscriptionDetails())));
    };
    BrandSubscriptionView = tslib_1.__decorate([
        observer
    ], BrandSubscriptionView);
    return BrandSubscriptionView;
}(React.Component));
export default BrandSubscriptionView;
//# sourceMappingURL=BrandSubscriptionView.js.map